import type { JobHistoryEventResponseType } from '../JobApi';
import { JobHistoryItem } from './JobHistoryItem';

export class JobHistoryImporter {
    static convert(jobHistoryResponse: JobHistoryEventResponseType[]) {
        let jobHistoryList: JobHistoryItem[] = [];
        let lastNewVehicleId: number | null = null;
        let lastProcessStatusId: number | null = 1;
        let lastVehicleName: string | null = null;
        for (let jobHistoryEvent of jobHistoryResponse) {
            let h = new JobHistoryItem(jobHistoryEvent);

            // update lastNewVehicleId
            if (h.getNewVehicleId() === null) {
                if (lastNewVehicleId !== null) {
                    h.setNewVehicleId(lastNewVehicleId);
                }
            } else {
                lastNewVehicleId = h.getNewVehicleId();
            }

            // update lastProcessStatusId
            if (h.getNewProcessStatusId() === null) {
                if (lastProcessStatusId !== null) {
                    h.setNewProcessStatusId(lastProcessStatusId);
                }
            } else {
                lastProcessStatusId = h.getNewProcessStatusId();
            }

            if (h.getNewVehicleName() === null) {
                if (lastVehicleName !== null) {
                    h.setNewVehicleName(lastVehicleName);
                }
            } else {
                lastVehicleName = h.getNewVehicleName();
            }

            jobHistoryList.push(h);
        }
        return jobHistoryList;
    }
}
